import axios from 'axios';
import { URL_GET_CONTACT_TYPES } from 'constants/urls';

/**
 * @function getContactTypes
 * @async
 * @returns { Promise<Array> } data
 */
async function getContactTypes() {
	const { data } = await axios({
		method: 'GET',
		url: URL_GET_CONTACT_TYPES,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
		},
		options: 'cantrackv3',
		data: null,
	});
	return data;
}

export default getContactTypes;
